import pdf from "../../../../assets/MOCK_OD/img/pdf-svgrepo-com.svg";

import React, { useState, useEffect, useContext, useRef } from "react";
import diamond from "../../../../assets/UFC_DC_V1/img/diamond.png";
import ssl from "../../../../assets/UFC_DC_V1/img/ssl.png";
import charterhouseclaims from "../../../../assets/UFC_DC_RF_V1/img/charterhouseclaims.png";
import excellent_review from "../../../../assets/UFC_DC_V1/img/excellent-review.svg";
import pound from "../../../../assets/UFC_DC_V1/img/pound.png";
import bg_money_sml from "../../../../assets/UFC_DC_V1/img/bg-money-sml.png";
import logo_white from "../../../../assets/UFC_DC_V1/img/logo-white.png";
import GtmDataLayer from "../../../../Utility/GtmDataLayer";
import { useQuestionnaire } from "../../../../Hooks/useQuestionnaire";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import { usePageLoad } from "../../../../Hooks/usePageLoad";
import { getPageName } from "../../../../Constants/PageNames";
import { useHistory } from "react-router-dom";
import { useAddressApi } from "../../../../Hooks/useAddressApi";

import LoaNew from "./LoaNew";
import ChAuthNew from "./ChAuthNew";
import ChWelcomePcp from "./ChWelcomePcp";
import TermsAndCondtion from "./TermsAndCondtion";
import Privacypolicy from "./Privacypolicy";
import KeyFacts from "./KeyFacts";
import ExampleConsentForm from "./ExampleConsentForm";
import ReferralFee from "./ReferralFee";
import CHSummAndInfo from "./CHSummAndInfo";

const Questions = () => {
  const query = new URLSearchParams(window.location.search);
  const [questOne, setQuestOne] = useState("hide");
  const [questTwo, setQuestTwo] = useState("show");
  const [showRefundSection, setShowRefundSection] = useState("");
  const [btnDisable, setBtnDisable] = useState(true);
  const [questThree, setQuestThree] = useState("hide");
  const [bacKbtnId, setBacKbtnId] = useState("1");
  const [estimatedRefund, setEstimatedRefund] = useState("");
  const [unaffordableRefund, setUnaffordableRefund] = useState("");
  const [question118, SetQuestion118] = useState("");
  const [dropdown, setDropdown] = useState(false);
  const selectedBank = JSON.parse(localStorage.getItem("selectedBank")) || [];
  const { isLoading, SaveQuestionnaire } = useQuestionnaire();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const formdata = JSON.parse(localStorage.getItem("formData"));
  const query_string = localStorage.getItem("queryString");
  const { savePageLoad, calledOnce } = usePageLoad();
  const splitName = localStorage.getItem("split_name");
  const uuid = visitorParameters.visitor_parameters.uuid;
  const history = useHistory();
  const { addressCheck } = useAddressApi();
  let nextPage = "questionaire_RF_V1";

  //PDF
  const [loa, setLoa] = useState(false);
  const [chAuth, setChAuth] = useState(false);
  const [chWelcomePcp, setChWelcomePcp] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [keyFacts, setKeyFacts] = useState(false);
  const [exampleConscentForm, setExampleConscentForm] = useState(false);
  const [referralFee, setReferralFee] = useState(false);
  const myRef = useRef(null);
  const [CHsumm, setCHSumm] = useState(false);
  
  useEffect(() => {
    // Set a timeout to scroll into view after 2 seconds (2000ms)
    const timer = setTimeout(() => {
      if (myRef.current) {
        myRef.current.scrollIntoView({
          behavior: "smooth", // Optional: smooth scroll
          block: "start", // Aligns the element at the top of the viewport
        });
      }
    }, 500); // Delay in milliseconds (2 seconds)

    // Cleanup timeout if component unmounts or effect re-runs
    return () => clearTimeout(timer);
  }, [questTwo]);

  useEffect(() => {
    if (!!uuid && !calledOnce) {
      const data = {
        uuid,
        page_name: getPageName("consents_page"),
        status: "visited",
        source: "regular",
      };
      (async () => {
        await savePageLoad(
          visitorParameters.visitor_parameters,
          data,
          "visited_status",
          splitName,
          query_string,
          visitorParameters.data
        );
      })();
    }
  }, [uuid, calledOnce]);

  const completePageLeadStatus = () => {
    const data = {
      uuid,
      page_name: getPageName("consents_page"),
      status: "completed",
      source: "regular",
    };
    (async () => {
      await savePageLoad(
        visitorParameters.visitor_parameters,
        data,
        "visited_status",
        splitName,
        query_string,
        visitorParameters.data
      );
    })();
  };

  let question_data = {};

  const storeQuestionnire = async (question_data) => {
    const response = await SaveQuestionnaire(
      visitorParameters.visitor_parameters,
      question_data,
      "question_store",
      visitorParameters.data,
      query_string,
      formdata
    );
  };
  let flage = false;

  const nextQuestion = (e) => {
    console.log("e.target.value", e.target.value);
    setEstimatedRefund(e.target.value);
    if (e.target.value) {
      GtmDataLayer({
        question: "free online scan",
      });
      flage = true;
      question_data = {
        question_id: 114,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
    }
    completePageLeadStatus();
    history.push(
      `/loader_UFC_DC_RF_V1?uuid=${visitorParameters.visitor_parameters.uuid}&nextPage=${nextPage}`
    );

    if (flage) {
      storeQuestionnire(question_data);
      let _existingEntries = JSON.parse(localStorage.getItem("questionData"));
      if (_existingEntries == null) _existingEntries = [];
      let existingIndex = _existingEntries.findIndex(
        (entry) => entry.question_id === question_data.question_id
      );
      if (existingIndex !== -1) {
        _existingEntries.splice(existingIndex, 1);
      }
      _existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(_existingEntries));
    }
  };

  const prevQuestion = (e) => {
    const value = Number(e.target.value);
    console.log("value", value);
    setBacKbtnId((prevId) => {
      const newId = Math.max(1, prevId - 1); // Prevents going below 1

      setBtnDisable(newId === 1); // Disable only if backBtnId is 1

      return newId;
    });
    switch (value) {
      case 1:
        setBtnDisable(true);
        setShowRefundSection("");
        setQuestOne("show");
        setQuestTwo("hide");
        break;

      case 2:
        setBacKbtnId(1); // Moving back from 2 to 1
        setQuestThree("hide");
        setQuestTwo("show");
        setBtnDisable(false); // Re-enable button if it was disabled
        break;
      default:
        console.warn("Unexpected value in prevQuestion:", value);
    }
  };

  const nextSlide = (e) => {
    setUnaffordableRefund(e.target.value);
    if (e.target.value) {
      GtmDataLayer({
        question: "other oppertunities",
      });
      flage = true;
      question_data = {
        question_id: 118,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
    }
    if(e.target.value =="326") {
      localStorage.setItem('isPCPconsent','1');
    } else {
      localStorage.setItem('isPCPconsent','0');
    }
    if (estimatedRefund == "318") {
      if (e.target.value == "327") {
        addressCheck(visitorParameters.visitor_parameters, formdata);
      }
      completePageLeadStatus();
      // history.push(
      //   `/loader_UFC_DC_RF_V1?uuid=${visitorParameters.visitor_parameters.uuid}&nextPage=${nextPage}`
      // );
    }
    setBacKbtnId(2);
    setQuestTwo("hide");
    setQuestThree("show");
    setBtnDisable(false);

    if (flage) {
      storeQuestionnire(question_data);
      let _existingEntries = JSON.parse(localStorage.getItem("questionData"));
      if (_existingEntries == null) _existingEntries = [];
      let existingIndex = _existingEntries.findIndex(
        (entry) => entry.question_id === question_data.question_id
      );
      if (existingIndex !== -1) {
        _existingEntries.splice(existingIndex, 1);
      }
      _existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(_existingEntries));
    }
  };

  const nextBasicDetails = (e) => {
    SetQuestion118(e.target.value);
    if (e.target.value) {
      GtmDataLayer({
        question: "finance evaluation",
      });
      flage = true;
      question_data = {
        question_id: 115,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
      if (flage) {
        storeQuestionnire(question_data);
        let _existingEntries = JSON.parse(localStorage.getItem("questionData"));
        if (_existingEntries == null) _existingEntries = [];
        let existingIndex = _existingEntries.findIndex(
          (entry) => entry.question_id === question_data.question_id
        );
        if (existingIndex !== -1) {
          _existingEntries.splice(existingIndex, 1);
        }
        _existingEntries.push(question_data);
        localStorage.setItem("questionData", JSON.stringify(_existingEntries));
      }
      completePageLeadStatus();
      history.push(
        `/loader_UFC_DC_RF_V1?uuid=${visitorParameters.visitor_parameters.uuid}&nextPage=${nextPage}`
      );
    }
  };

  useEffect(() => {
    if (questThree?.toLowerCase() === "show") {
      window.scrollTo(0, 0);
    }
  }, [questThree]);
  return (
    <>
      <section className={`banner  parallax-container `}>
        <div className="d-lg-none d-md-none d-sm-block d-block money-bg-mobile">
          <img src={bg_money_sml} alt="" />
        </div>
        <div className="container">
          <div>
            <div className="brand">
              <div className="logo pt-3">
                <a href="index.html">
                  <img src={logo_white} height="60" alt="" />
                </a>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <div className="container pt-3 px-lg-2 px-md-2 px-sm-0 px-0  ">
          <div className="inner-section   ">
            <div className="body-questionnaire mb-4">
              <div className="inner rounded-4">
                <div className="swiper qsSlider slide-up-now">
                  <div className="swiper-wrapper">
                    <div className={`swiper-slide slide-up-now ${questTwo}`}>
                      <h2 className="qs-title  ">
                        While reviewing the information in your Credit Report,
                        we’ve identified a potential opportunity to pursue
                        further claims for mis-sold car finance.
                      </h2>
                      <p className="fs-16" ref={myRef}>
                        We believe our partner, Charterhouse Claims, a premier
                        claims management company, is well suited to support you
                        with this claim for
                        <mark className="text-highlight">
                          an opportunity to earn £1,000's* or more per car loan!
                        </mark>
                        &nbsp;if you would like, we may refer your details to
                        them.
                      </p>
                      <ul className="list-content list-cont-sty mt-lg-0 mt-2 mb-0">
                        <li>
                          You do not need to use a claims management company to
                          make a complaint, you can make a complaint to the
                          lender, or you can refer your claim to the Financial
                          Ombudsman Service (FOS) yourself for free.
                        </li>
                        <li>
                          Charterhouse Claims provide a no win no fee service**.
                          we will charge a fee of between 18-36% (inclusive of
                          VAT) of your compensation, The fee structure can be
                          viewed
                          <button
                            className="btn btn-link fw-semibold ps-1 click-style"
                            onClick={() => setKeyFacts((prev) => !prev)}
                          >
                            here
                          </button>
                        </li>
                        <li>
                          We may receive a
                          <button
                            className="btn btn-link fw-semibold ps-1 click-style"
                            onClick={() => setReferralFee((prev) => !prev)}
                          >
                            referral-fee
                          </button>
                        </li>
                      </ul>
                      <ul className="btn-option optinal-items  two-options  py-3   ">
                        <li>
                          <div
                            className=" option_but animation-effct"
                            onClick={nextSlide}
                          >
                            <input
                              type="radio"
                              id="326"
                              value="326"
                              name="check3"
                            />
                            <label
                              for="326"
                              className=" align-items-center endQuest "
                            >
                              <div> Yes, Please Pursue</div>
                            </label>
                          </div>
                        </li>
                        <li>
                          <div className="option_but" onClick={nextSlide}>
                            <input
                              type="radio"
                              id="327"
                              name="check3"
                              value="327"
                            />
                            <label for="327" className="endQuest">
                              <div> No, Thank You </div>
                            </label>
                          </div>
                        </li>
                      </ul>
                      <div className="d-flex justify-content-center ch_house_claims">
                        <img
                          src={charterhouseclaims}
                          alt="charterhouseclaims"
                        />
                      </div>
                      <div className="fs-14 normal-content">
                        <p className="text-center p-14">
                          Please ensure you have read all of the documents
                          listed within the link below
                        </p>
                      </div>

                      <p className="text-center p-14">
                        <a
                          href=""
                          onClick={(e) => {
                            e.preventDefault();
                            setDropdown((prev) => !prev);
                          }}
                        >
                          View Charterhouse Claims Documents
                        </a>
                      </p>
                      {dropdown && (
                        <div className="side-toggle bg-white px-3 py-2 mb-3 rounded-3 shadow-sm">
                          <ul className="links ps-0 mt-0 mb-0">
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setLoa((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Letter of Authority
                              </a>
                            </li>
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setChAuth((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Certificate of Authenticity
                              </a>
                            </li>
                            {/* <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setKeyFacts((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Key Facts
                              </a>
                            </li> */}
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setCHSumm((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Charterhouse Summary Information
                              </a>
                            </li>
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setExampleConscentForm((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Consent Form
                              </a>
                            </li>
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setPrivacyPolicy((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Privacy Policy
                              </a>
                            </li>
                            {/* <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setChWelcomePcp((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Welcome Letter
                              </a>
                            </li> */}
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setTermsAndConditions((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Terms and Conditions
                              </a>
                            </li>
                          </ul>
                        </div>
                      )}
                      <p
                        className="fs-14 mobile-para-spacing"
                        style={{
                          fontFamily: "Arial, Helvetica, sans-serif",
                          fontStyle: "italic",
                          fontSize: "13px",
                        }}
                      >
                        Charterhouse Claims is authorised and regulated by the
                        Financial Conduct Authority (FCA) for regulated claims
                        management services. Our reference number is: 832999.
                        You can check this on Financial Services Register at{" "}
                        <a href="https://register.fca.org.uk" target="_blank">
                          https://register.fca.org.uk.{" "}
                        </a>
                        Registered address: Charterhouse Claims LTD, Stafford
                        Court,{" "}
                        <a
                          href="https://www.google.com/maps/place/Stafford+Court,+145+Washway+Rd,+Sale+M33+7PE,+UK/@53.4197778,-2.3312612,17z/data=!3m1!4b1!4m6!3m5!1s0x487bac5b656ccf03:0x4747ca65c9757d20!8m2!3d53.4197778!4d-2.3312612!16s%2Fg%2F1tcvntxf?entry=ttu&g_ep=EgoyMDI1MDYwOC4wIKXMDSoASAFQAw%3D%3D"
                          target="_blank"
                        >
                          145 Washway Road, Sale, Manchester, M33 7PE
                        </a>
                        .
                      </p>
                      <p className="fs-14 mobile-para-spacing">
                        *An FCA investigation revealed that the average customer
                        on a £10,000 PCP agreement over four years has been
                        overcharged by more than £1,100 (
                        <a
                          href="https://www.thesun.co.uk/money/30635528/car-finance-misselling-scandal-money-fca/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://www.thesun.co.uk/money/30635528/car-finance-misselling-scandal-money-fca/
                        </a>
                        )
                      </p>
                      <div className="fs-14">
                        ** If we are not successful in your claim, you do not
                        pay anything. Clients have a 14 day “Cooling-Off” period
                        during which time they may cancel at any time without
                        charge. After this time, cancellation may result in the
                        application of the Cancellation Fee. For more
                        information
                        <a
                          className="btn btn-link fw-semibold ps-1 click-style btn-plese-click"
                          onClick={() => setKeyFacts((prev) => !prev)}
                        >
                          please click here
                        </a>
                      </div>
                    </div>
                    <div className={`swiper-slide slide-up-now ${questThree}`}>
                      <h2 className="qs-title  ">
                        You may be eligible for significantly more than just
                        overdraft-related refunds.
                      </h2>
                      <p className="fs-16">
                        If you regularly lived in your overdraft or couldn’t
                        maintain a positive bank balance, it’s very likely that
                        other financial products or charges during that time
                        were also unaffordable. We can check these for you — for
                        free.
                      </p>

                      <ul className="btn-option optinal-items  two-options    ">
                        <li>
                          <div
                            className=" option_but "
                            onClick={nextBasicDetails}
                          >
                            <input
                              type="radio"
                              id="320"
                              value="320"
                              name="check2"
                            />
                            <label
                              for="320"
                              className=" align-items-center endQuest"
                            >
                              <div> Yes, Please Pursue </div>
                            </label>
                          </div>
                        </li>

                        <li>
                          <div
                            className="option_but"
                            onClick={nextBasicDetails}
                          >
                            <input
                              type="radio"
                              id="321"
                              name="check2"
                              value="321"
                            />
                            <label for="321" className="endQuest">
                              <div> No, Thank You </div>
                            </label>
                          </div>
                        </li>
                      </ul>
                      <div className="mt-2 mb-4 text-center">
                        <div>
                          <button
                            className="back-btn mainbckBtn bi bi-chevron-left"
                            type="button"
                            value={bacKbtnId}
                            onClick={prevQuestion}
                            disabled={btnDisable}
                          >
                            Back
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=""></div>
                </div>
                <div className="mt-2 mb-3 justify-content-between  align-items-center text-center slide-up-now">
                  <div className="ms-auto d-flex justify-content-center g-2 pe-lg-3 pe-md-3 ps-sm-0 pe-0 mb-lg-0 mb-md-0 mb-sm-4  mb-4">
                    <div>
                      <img className="ps-2" height="28" src={ssl} alt="" />{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pt-lg-4 pt-md-5 pt-sm-3 pt-3">
              <div className="d-flex text-danger">
                <div className="pe-2"></div>
                <div>
                  <p className={` text-black ${questThree}`}>
                    This could include credit cards, payday loans, catalog
                    credit, or other charges that were approved while your
                    account was in a negative balance.{" "}
                    <strong>
                      Our clients average refund for each unaffordable credit is
                      £2,200*.{" "}
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {loa && <LoaNew close={() => setLoa(false)} />}
      {chAuth && <ChAuthNew close={() => setChAuth(false)} />}
      {chWelcomePcp && <ChWelcomePcp close={() => setChWelcomePcp(false)} />}
      {termsAndConditions && (
        <TermsAndCondtion close={() => setTermsAndConditions(false)} />
      )}
      {privacyPolicy && <Privacypolicy close={() => setPrivacyPolicy(false)} />}
      {keyFacts && <KeyFacts close={() => setKeyFacts(false)} />}
      {CHsumm && <CHSummAndInfo close={() => setCHSumm(false)} />}
      {exampleConscentForm && (
        <ExampleConsentForm close={() => setExampleConscentForm(false)} />
      )}
      {referralFee && <ReferralFee close={() => setReferralFee(false)} />}
    </>
  );
};
export default Questions;
